// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"86da9520","942":"41ec67f6"}[chunkId] + ".chunk.js";
};